/**
 * Scroll locker
 */
 let scrollPosition = 0;
 const body = document.querySelector('body');

 function enabledBodyScrollLock() {
   scrollPosition = $(window).scrollTop();
   body.style.overflow = 'hidden';
   body.style.position = 'fixed';
   body.style.top = `-${scrollPosition}px`;
   body.style.width = '100%';
 }

 function disableBodyScrollLock() {
   body.style.removeProperty('overflow');
   body.style.removeProperty('position');
   body.style.removeProperty('top');
   body.style.removeProperty('width');
   window.scroll({top: scrollPosition, left: 0});
 }

 export const ScrollLocker = {
   lock: enabledBodyScrollLock,
   unlock: disableBodyScrollLock
 };
